import { useAuth0 } from "@auth0/auth0-react";
import {
  ContentDelivery_V1,
  ContentDelivery_V2,
  ContentDelivery_V3,
} from "@rw1/auto-generated-clients";
import { useAppConfig, useEnvConfig } from "rwo-react";
import { setAccessTokenProvider } from "./accessTokenProvider";
import { joinUrl } from ".";

let contentDeliveryClientV1:
  | ContentDelivery_V1.ContentDeliveryClientV1
  | undefined;
let contentDeliveryClientV2:
  | ContentDelivery_V2.ContentDeliveryClientV2
  | undefined;
let contentDeliveryClientV3:
  | ContentDelivery_V3.ContentDeliveryClientV3
  | undefined;

export const useContentDeliveryServiceV1 =
  (): ContentDelivery_V1.ContentDeliveryClientV1 => {
    const { getAccessTokenSilently } = useAuth0();
    const { backendAddress } = useEnvConfig();
    const { config } = useAppConfig();

    contentDeliveryClientV1 ??= new ContentDelivery_V1.ContentDeliveryClientV1(
      joinUrl(backendAddress, config["CDSApiSuffix"])
    );
    setAccessTokenProvider(contentDeliveryClientV1, getAccessTokenSilently);

    return contentDeliveryClientV1;
  };

export const useContentDeliveryServiceV2 =
  (): ContentDelivery_V2.ContentDeliveryClientV2 => {
    const { getAccessTokenSilently } = useAuth0();
    const { backendAddress } = useEnvConfig();
    const { config } = useAppConfig();

    contentDeliveryClientV2 ??= new ContentDelivery_V2.ContentDeliveryClientV2(
      joinUrl(backendAddress, config["CDSV2ApiSuffix"])
    );
    setAccessTokenProvider(contentDeliveryClientV2, getAccessTokenSilently);

    return contentDeliveryClientV2;
  };

export const useContentDeliveryServiceV3 =
  (): ContentDelivery_V3.ContentDeliveryClientV3 => {
    const { getAccessTokenSilently } = useAuth0();
    const { backendAddress } = useEnvConfig();
    const { config } = useAppConfig();

    contentDeliveryClientV3 ??= new ContentDelivery_V3.ContentDeliveryClientV3(
      joinUrl(backendAddress, config["CDSV3ApiSuffix"])
    );
    setAccessTokenProvider(contentDeliveryClientV3, getAccessTokenSilently);

    return contentDeliveryClientV3;
  };
